import Vue from 'vue';
import App from "./App.vue";
import VueLazyload from 'vue-lazyload'

document.addEventListener("DOMContentLoaded", function () {

    if (document.getElementById('news-page')) {

        Vue.use(VueLazyload);

        new Vue({
            el: '#app',
            data: {
                posts: null,
                search: ''
            },
            render: h => h(App)
        });

        // let myposts = new wp.api.collections.Posts();
        // console.log(myposts);

    }


});